"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireDefault(require("react"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

var SvgIconTrash = function SvgIconTrash(props) {
  return /*#__PURE__*/_react.default.createElement("svg", _extends({
    viewBox: "0 0 48 48",
    "aria-label": "trash icon",
    fill: "currentColor",
    fillRule: "evenodd"
  }, props), /*#__PURE__*/_react.default.createElement("title", null, 'Trash Icon'), /*#__PURE__*/_react.default.createElement("path", {
    d: "M6.5 10.563V8.374A1.87 1.87 0 018.375 6.5h8.75l.734-1.46A1.853 1.853 0 0119.531 4h8.93c.71 0 1.36.398 1.68 1.04l.734 1.46h8.75A1.87 1.87 0 0141.5 8.375v2.187a.94.94 0 01-.938.938H7.437a.94.94 0 01-.937-.938zM39 14.936V40.25c0 2.07-1.68 3.75-3.75 3.75h-22.5C10.68 44 9 42.32 9 40.25V14.937A.94.94 0 019.938 14h28.125a.94.94 0 01.937.938zM17.75 20.25c0-.688-.562-1.25-1.25-1.25-.687 0-1.25.563-1.25 1.25v17.5c0 .688.563 1.25 1.25 1.25.688 0 1.25-.563 1.25-1.25zm7.5 0c0-.688-.562-1.25-1.25-1.25-.687 0-1.25.563-1.25 1.25v17.5c0 .688.563 1.25 1.25 1.25.688 0 1.25-.563 1.25-1.25zm7.5 0c0-.688-.562-1.25-1.25-1.25-.687 0-1.25.563-1.25 1.25v17.5c0 .688.563 1.25 1.25 1.25.688 0 1.25-.563 1.25-1.25z"
  }));
};

var _default = SvgIconTrash;
exports.default = _default;